import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-filter-button',
  templateUrl: 'filter-button.component.html',
  styleUrls: ['filter-button.component.scss'],
  imports: [
    AsyncPipe,
    ButtonComponent,
    TranslatePipe,
    TranslateDirective,
    IconComponent
  ]
})
export class FilterButtonComponent implements OnInit {
  private readonly mediaQueryService = inject(MediaQueryService);

  readonly numberOfFilter = input<number>(undefined);
  readonly show = output<void>();

  breakpointChanges$: Observable<BreakpointState>;

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  hasFilter(): boolean {
    const numberOfFilter = this.numberOfFilter();
    return numberOfFilter !== undefined && numberOfFilter > 0;
  }

  showFilters(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.show.emit();
  }
}
